module.exports = __webpack_public_path__ + "img/background2.70e411d0.svg";